import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import MainMenu from "./MainMenu";
import * as React from "react";
import {Container, styled} from "@mui/system";
import Toolbar from "@mui/material/Toolbar";
import {useState} from "react";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import {useNavigate} from "react-router-dom";

const StyledToolbar = styled(Toolbar)(({theme}) => ({
    display: "flex",
    justifyContent: "center",
    width: "100%",
    "&.MuiToolbar-root": {
        padding: 0,
        minHeight: 'unset',
    }
}));

const blueBarLinkButtonSx = {
    fontSize: '16px',
    lineHeight: '18px',
    minWidth: 'unset',
    padding: 0,
    "&:hover": {
        backgroundColor: "transparent",
        textDecoration: "underline",
    },
};

export const ToolbarSecond = ({accessibility, stage, profile, requireAuthNavigate}) => {
    const [menuOpen, setMenuOpen] = useState({})
    const navigate = useNavigate();
    const isKuhniVersoMebel =
        window.location.hostname === "kuhni-verso-mebel.upme.by"
        || window.location.hostname === "kuhni-verso-mebel.t.upme.by";

    const handleProtectedNavigate = (path) => {
        if (profile) {
            navigate(path);
            return;
        }
        requireAuthNavigate?.(path);
    };
    return <AppBar
        position="static"
        sx={{
            display: 'flex',
            justifyContent: "center",
            alignItems: 'center',
            width: '100%',
            minHeight: '54px',
            backgroundColor: (theme) => theme.palette.primary.main,
            boxShadow: "none",
            '@media (max-width: 1023px)': {
                display: 'none',
            },
        }}>
        <Container sx={{
            "&.MuiContainer-root": {
                maxWidth: "1668px",
                '@media (max-width: 1023px)': {
                    maxWidth: '900px',
                },
            }
        }}>
            <StyledToolbar>
                <Box sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    width: '100%',
                    gap: '8px 40px',
                    '@media (max-width: 1023px)': {
                        gap: '8px 30px',
                    },
                    '@media (max-width: 940px)': {
                        gap: '8px 20px',
                    },
                }}>
                    {isKuhniVersoMebel && profile && (
                        <>
                            <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                                <IconButton
                                    onClick={() => navigate('/catalog/drafts')}
                                    color="inherit"
                                    sx={blueBarLinkButtonSx}
                                >
                                    <Typography component="div" sx={{flexGrow: 1, fontSize: 'inherit', lineHeight: 'inherit'}}>
                                        Мои черновики
                                    </Typography>
                                </IconButton>
                            </Box>
                            <Box sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
                                <IconButton
                                    onClick={() => handleProtectedNavigate('/customer/kitchen-orders')}
                                    color="inherit"
                                    sx={blueBarLinkButtonSx}
                                >
                                    <Typography component="div" sx={{flexGrow: 1, fontSize: 'inherit', lineHeight: 'inherit'}}>
                                        Мои заказы
                                    </Typography>
                                </IconButton>
                            </Box>
                        </>
                    )}
                    {(stage === 0 || stage > 7) && accessibility?.menu?.map(menu => {
                        const subMenu = accessibility.subMenu.filter((subMenu) => subMenu.menuType === menu.type)
                        return <MainMenu
                            key={menu.type}
                            name={menu.type}
                            handleMenu={(event) => setMenuOpen({
                                type: menu.type,
                                anchor: event.currentTarget
                            })}
                            anchorEl={menuOpen.type === menu.type && menuOpen.anchor}
                            handleClose={() => setMenuOpen({})}
                            menuItems={subMenu}
                            labelName={menu.name}
                        />
                    })}
                </Box>

            </StyledToolbar>
        </Container>
    </AppBar>
}